export default {
  "content": "<path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M4 1c0-.6.4-1 1-1s1 .5 1 1v4c0 .6-.4 1-1 1a1 1 0 01-1-1V1zm6 8c0-.6.4-1 1-1s1 .5 1 1v4c0 .6-.4 1-1 1a1 1 0 01-1-1V9z\" clip-rule=\"evenodd\" opacity=\".2\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "12",
    "height": "16",
    "fill": "none",
    "viewBox": "0 0 12 16"
  }
};